// P1 Business Health primary gauge + Executive Summary. Extracted verbatim
// from AuditPreview.jsx (W2b). Same DOM, test-ids, copy, inline styles.
// Renders nothing when `businessHealth` is falsy (caller responsibility).
import BlackRockBand from "../BlackRockBand";

export default function PreviewBusinessHealth({ businessHealth, executiveSummary }) {
  if (!businessHealth) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 40 }} data-testid="preview-business-health-card">
      <BlackRockBand
        score={businessHealth.score}
        label={businessHealth.label}
        bandId={businessHealth.band}
        explanation={businessHealth.explanation}
        metricLabel="Business Health"
        size="primary"
        testId="preview-business-health"
      />
      <p className="sf-mono" style={{ fontSize: 11, color: "var(--sf-muted)", lineHeight: 1.6, marginTop: 12, letterSpacing: "0.02em" }} data-testid="preview-bh-methodology">
        Business Health is the weighted composite of five supporting systems: Revenue Recovery, Opportunity, Automation Readiness, Operations, and Retention.
      </p>
      {(executiveSummary || businessHealth.executive_summary) && (
        <div
          data-testid="preview-executive-summary"
          style={{
            marginTop: 26, paddingTop: 22,
            borderTop: "1px solid #22262B",
          }}
        >
          <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Executive Summary</div>
          <p style={{
            fontSize: 16, lineHeight: 1.6,
            color: "var(--sf-offwhite)", maxWidth: 720,
          }}>
            {executiveSummary || businessHealth.executive_summary}
          </p>
        </div>
      )}
    </div>
  );
}
